import React, { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import "./HomePage.css";
import FeaturedProductCard from "./FeaturedProductCard";
import { getProducts } from "../../services/productService";

const fallbackProducts = [
  {
    img: "/kuku-assets/products/dry-chapti-kachori/1 chapti kachori.jpg",
    title: "Jamnagari Special Chapti Kachori",
    price: "300",
    badge: "5% OFF",
    weights: ["250 gm", "500 gm"],
    slug: "dry-chapti-kachori",
  },
  {
    img: "/kuku-assets/products/dry-round-kachori/1 dry-round.jpg",
    title: "Jamnagari Special Dry Kachori",
    price: "300",
    badge: null,
    weights: [],
    slug: "dry-round-kachori",
  },
  {
    img: "/kuku-assets/products/dryfruit/1 dry-fruit.jpg",
    title: "Dry Fruit Kachori",
    price: "300",
    badge: null,
    weights: [],
    slug: "dry-fruit-kachori",
  },
  {
    img: "/kuku-assets/products/rajbhog-kachori/1 rajbhog.jpg",
    title: "Jamnagari Special Rajbhog Kachori",
    price: "300",
    badge: null,
    weights: [],
    slug: "rajbhog-kachori",
  },
];

function getHomepageProducts(products = []) {
  return products.filter(
    (product) => Number(product?.is_savour) === 1
  );
}

const FeaturedProducts = () => {
  const sectionRef = useRef(null);
  const { data: productResponse } = useQuery({
    queryKey: ["product"],
    queryFn: getProducts,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("active");
          } else {
            if (e.boundingClientRect.top > 0) {
              e.target.classList.remove("active");
            }
          }
        });
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  const apiProducts = productResponse?.data;
  const liveProducts = getHomepageProducts(apiProducts || []);
  const displayedProducts =
    Array.isArray(apiProducts) ? liveProducts : fallbackProducts;

  return (
    <section className="hp-products hp-section hp-reveal" ref={sectionRef}>
      <div className="fp-section-inner">
        <h2 className="hp-products-heading">Savor all-time favorites!</h2>
        <div className="fp-grid">
          {displayedProducts.map((product) => (
            <FeaturedProductCard
              key={product.product_id || product.slug || product.title}
              product={product}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
